export default "__VITE_ASSET__eda338ab__"